import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
import { Api } from "../../../providers/api";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";
import { UnprocessableEntityError } from "../../../providers/api/errors/UnprocessableEntityError";
import { ErrorResponse } from "../../../providers/api/responses/ErrorResponse";
import { DesktopService } from "../../../providers/desktop-service";
import { BlankDesktopPage } from "../blank/blank";

@Component({
    selector: 'page-contact',
    templateUrl: 'contact.html'
})

export class ContactPage {

    public name: string;
    public email: string;
    public telephone: string;
    public message: string;

    constructor(
        public api: Api,
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public desktopService: DesktopService,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('ContactUs');
    }

    public submit() {
        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.postContact({
            name: this.name,
            email: this.email,
            telephone: this.telephone,
            message: this.message
        }).finally(() => {
            loading.dismiss();
        }).subscribe(response => {
            if (response.success) {
                this.showAlert('Your message has been sent successfully!', 'Thank you');
            } else {
                this.showError('There was an error while attempting to send your message. Please try again.');
            }
        }, error => {
            if (error instanceof UnprocessableEntityError) {
                let errors = this.api.errorsToUl(error.errors);

                let alert = this.alertCtrl.create({
                    cssClass: 'alert-with-error-list',
                    title: 'Invalid Details',
                    subTitle: 'There were one or more issues with the information you entered',
                    message: errors.outerHTML,
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();
            } else if (error instanceof ErrorResponse) {
                this.showError(error.message);
            } else {
                this.showError('An unknown error has occured. Please try again.');
            }
        });
    }

    public showAlert(message: string, title: string) {
        let alert = this.alertCtrl.create({
            title: title,
            message: message,
            buttons: [{
                text: 'OK',
                handler: () => {
                    this.desktopService.getRightPane().setRoot(BlankDesktopPage);
                },
            }],
            enableBackdropDismiss: false,
        });

        alert.present();
    }

    public showError(message: string) {
        this.showAlert(message, 'Error');
    }
}



// WEBPACK FOOTER //
// ./src/pages/desktop/contact/contact.ts